module.exports = __webpack_public_path__ + "img/V45.9e1e3437.jpg";